import React, { Component } from 'react';
import { ErrorContent } from './error-views';

type Props = {
  children: React.ReactNode;
  fallback?: JSX.Element;
  scope: string;
};

type State = {
  fallback?: JSX.Element;
  hasError: boolean;
  scope: string;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = {
    fallback: this.props.fallback,
    hasError: false,
    scope: this.props.scope,
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    // When the scope changes, reset hasError.
    if (props.scope !== state.scope) {
      return {
        hasError: false,
        scope: props.scope,
      };
    }
    return null;
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.error(`[ErrorBoundary - ${this.props.scope}]`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          {this.state.fallback ? (
            this.state.fallback
          ) : (
            <ErrorContent variant="theme-and-localized" />
          )}
        </>
      );
    }

    return <>{this.props.children}</>;
  }
}
